import { useEffect, useState } from 'react'

import { ValidationStatus } from 'core-components/library/validation'
import { addPendingFn, IPendingButton, removeAddedPending } from 'core/routes/urlController'

interface IUseTargetsUrlDeps {
  resetChanged: () => void
  apply: (data: any) => void
  changed: boolean
  isNotChanged: boolean
  urlDeps: string[]
  isCancelIfChanged?: boolean
}

export const useTargetsUrlDeps = (options: IUseTargetsUrlDeps) => {
  const { resetChanged, apply, changed, isNotChanged, urlDeps, isCancelIfChanged } = options

  const [pending] = useState({
    data: [] as any,
    currStatus: ValidationStatus.WIP,
  })
  const [urlProcessing] = useState<{
    ctxObject?: { addPendingFn: addPendingFn; unregistr: () => void }
    removePending?: removeAddedPending
    registr?: () => any
  }>({})

  useEffect(() => {
    return () => {
      if (urlProcessing.removePending) {
        urlProcessing.removePending()
        delete urlProcessing.removePending
      }
    }
  }, [])

  const addPendingFn = () => {
    if (urlProcessing.ctxObject) {
      const buttons: IPendingButton[] = [
        {
          callback: async () => {
            resetChanged()
            if (urlProcessing.removePending) {
              urlProcessing.removePending()
              delete urlProcessing.removePending
            }
            return true
          },
          props: {
            children: 'Discard changes',
            color: 'danger',
          },
        },
        {
          callback: async () => {
            if (urlProcessing.removePending) {
              urlProcessing.removePending()
              delete urlProcessing.removePending
            }
            await apply(pending.data)

            return isCancelIfChanged && changed ? false : true
          },
          props: {
            children: 'Save changes',
          },
          calculateProps: () => ({
            disabled: pending.currStatus !== ValidationStatus.Valid,
          }),
        },
        {
          callback: async () => {
            return false
          },
          props: {
            children: 'Cancel',
            color: 'grey',
          },
        },
      ]
      urlProcessing.removePending = urlProcessing.ctxObject.addPendingFn({
        buttons,
        message: `You have unsaved data, would you really like to leave the page?`,
        parameters: urlDeps || [],
      })
    }
  }

  const updatePendingData = (newData?: any, currStatus?: ValidationStatus) => {
    if (newData) {
      pending.data = [...newData]
    }
    if (currStatus) {
      pending.currStatus = currStatus
    }
  }

  const registrUrlDeps = (context: any) => {
    if (urlDeps && !urlProcessing.ctxObject) {
      urlProcessing.ctxObject = context.registr()
    }
  }

  useEffect(() => {
    if (changed && !urlProcessing.removePending) {
      addPendingFn()
    } else if (!changed && urlProcessing.removePending) {
      urlProcessing.removePending()
      delete urlProcessing.removePending
    }
  }, [changed])

  if (isNotChanged && urlProcessing.removePending) {
    urlProcessing.removePending()
    delete urlProcessing.removePending
  }
  if (!isNotChanged && changed && !urlProcessing.removePending) {
    addPendingFn()
  }

  return { updatePendingData, registrUrlDeps }
}
